import React from "react";
import "./Ourteam.css";
import { Container } from "react-bootstrap";
import linkdin from "../../../../Asset/ourteam/linkdin.svg";

const teamMembers = [
  {
    name: "Chirag Bambhroliya",
    designation: "CEO and Director",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/q_auto/f_auto/v1776225948/image_2_l07kxe.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/q_auto/f_auto/v1776225948/image_2_l07kxe.png",
    linkdinLink: "https://www.linkedin.com/in/chirag-bambhroliya-90954b343/",
  },
  {
    name: "Khushi Sakhiya",
    designation: "HR",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/q_auto/f_auto/v1776160650/Image_2_ey4zuh.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/q_auto/f_auto/v1776160650/Image_4_bnxzrl.png",
    linkdinLink: "https://www.linkedin.com/in/khushi-sakhiya-423819248/",
  },
  {
    name: "Siddharth Bhesaniya",
    designation: "MARN Stack Developer",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770964139/Image_5_v3hsol.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770808642/Image_5_ujqzuu.png",
    linkdinLink:
      "https://www.linkedin.com/in/siddharth-bhesaniya-91b850168?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    name: "Arshita Bhikhadiya",
    designation: "Python Developer",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1776747353/Image_4_igvm2q.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1776747353/Image_4_igvm2q.png",
    linkdinLink:
      "https://www.linkedin.com/in/arshita-bhikhadiya",
  },
  // {
  //   name: "Vivek Bhatt",
  //   designation: "ReactJs Developer",
  //   img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770965133/Image_7_xlwvwh.png",
  //   img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770808454/Image_4_htup71.png",
  //   linkdinLink: "https://www.linkedin.com/in/vivek-bhatt-01a79925a",
  // }, 
  {
    name: "Rutvi Bapodariya",
    designation: "ReactJs Developer",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1768279453/image_3_qtldqs.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1768279453/image_2_pyefao.png",

    linkdinLink:
      "https://www.linkedin.com/in/rutvi-bapodariya-49b82b275?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },
  {
    name: "Sagar Kava",
    designation: "NodeJs Developer",
    img1: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770809174/Image_6_qruelb.png",
    img2: "https://res.cloudinary.com/dtcfgwcav/image/upload/v1770809174/Image_6_qruelb.png",
    linkdinLink:
      "https://www.linkedin.com/in/sagar-kava-74635b222?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
  },

];

const Ourteam = () => {
  return (
    <>
      <section className="our-team-section">
        <Container>
          <div className="top-text-ourteam">
            <h2>
              OUR <span> TEAM</span>
            </h2>
          </div>
          <div className="row leadership-row">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="col-xl-4 col-md-4 col-sm-6 leadership-col"
              >
                <div className="leadership-card">
                  <div className="leadership-image-part pt-2">
                    <img
                      src={member.img1}
                      className="main-img"
                      alt={`${member.name} main`}
                    />
                    <img
                      src={member.img2}
                      className="hover-img"
                      alt={`${member.name} hover`}
                    />
                  </div>
                  <div className="introduction-part">
                    <h3 className="name w-75">{member.name}</h3>
                    <h6 className="designation mb-4 sm-mb-2">
                      {member.designation}
                    </h6>
                    <a
                      href={member.linkdinLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="linkdin">
                        <img src={linkdin} alt="LinkedIn" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Ourteam;
